export default __webpack_public_path__ + "static/js/hammer.static.js";